"use strict";

const renderer = require("./renderer");
const tokenizer = require("./tokenizer");

module.exports = function iaApi_parse_plugin(md, options) {
  md.renderer.rules.iaApi_parse = renderer(options);
  md.core.ruler.push("iaApi_parse", tokenizer(md, options));
};